module.exports = __webpack_public_path__ + "static/media/BakingMix.ed4a6d47.jpeg";